<script setup>

import {inject} from "vue";

const rootScope = inject('rootScope');
</script>

<template>
  <header class="hidden-xs">

      <div class="header-contain">
        <router-link :to=" rootScope.logged ? '/home' : '/terminos-condiciones'" >
          Cristal
<!--          <picture class="header-logo">
            <img src="https://objectstorage.sa-bogota-1.oraclecloud.com/n/axwjzswungq4/b/Colombiana_Bucket/o/logos%2Fpromo-colombiana.webp" alt="logo">
          </picture>-->
        </router-link>
        
    </div>
  </header>
</template>

<style scoped>

</style>
